export const environment = {
  production: true,
  APP_ID: '0cf2a791-f4e3-4d38-9597-f36c7ea0ab47',
  API_BASE_URL: 'https://promo.united.com/offers/api/chaseyearofyes',
  IMAGE_BASE_URL: 'https://promo.united.com/chaseyearofyes/public/images/',
  ASSETS_BASE_URL: 'https://promo.united.com/assets/img/',
};